import apiClient from './config'

var ENHANCE_PATH = '/enhanceImage'

export function enhanceImage(file, targetResolution, outputFormat) {
  if (!file || !(file instanceof File)) {
    return Promise.reject(new Error('请选择图片文件'))
  }

  var formData = new FormData()
  formData.append('file', file)
  formData.append('targetResolution', targetResolution || '4k')
  formData.append('outputFormat', outputFormat || 'JPEG')

  return apiClient.post(ENHANCE_PATH, formData, {
    timeout: 300000,
    headers: { 'Content-Type': undefined }
  }).then(function(resp) {
    var payload = resp && resp.data ? resp.data : resp
    if (payload && payload.imageUrl) return payload
    return Promise.reject(new Error('图片增强失败'))
  })
}

export default {
  enhanceImage: enhanceImage
}
